import React, {
    useEffect,
    useState
} from "react";
import {Container} from "react-bootstrap";

import {useClassNames} from "../../../Hooks/StyleHooks";
import {SurveyComponent} from "../../../Components/Pages/ConservationActions/SurveyComponent";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useSelector} from "react-redux";
import {service as ConservationActionService} from "../../../Services/ConservationActionService";
import {useEffectPromise} from "../../../Hooks/EffectHooks";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {useGetUrlToolSegment} from "../../../Hooks/RouteHooks";
import {useIsMounted} from "../../../Hooks/useIsMounted";

export const SurveyPage = props => {
    usePrimeCache([SurveyTypeService]);
    
    const isMounted = useIsMounted();
    const makePageRequest = useMakePageRequest();
    const classNames = useClassNames("sb-conservation-actions-" + surveyType?.code + "-page");
    
    const [conservationAction, setConservationAction] = useState(null);
    
    // TODO: make a selectContext selector to make this component more ignorant of the state structure?
    const {conservationAction: conservationActionId} = useSelector(state => state.contextState.context);
    const tool = useGetUrlToolSegment()();
    
    const surveyType = (SurveyTypeService.CachedValueByProperty(tool, 'code')?.result) ?? null;
    
    const loadConservationAction = async (useCache = false) => {
        if(conservationActionId != null && isMounted()) {
            setConservationAction(await fetchConservationAction(conservationActionId, useCache));
        }
    }
    
    const fetchConservationAction = async (conservationActionId, useCache = false) => {
        try {
            const result = (await makePageRequest(() => ConservationActionService.Get(conservationActionId, useCache)))?.result ?? null;
            return {...result}; // return a copy to avoid mutating the original object
        } catch (e) {
            console.log('loadModel failed for value:', conservationActionId, e);
        }
        return null;
    }
    
    useEffect(() => {
        void loadConservationAction();
    }, [conservationActionId, isMounted()]);
    
    if(!conservationAction || !surveyType) {
        return null;
    }

    return <Container className={classNames}>
        <SurveyComponent
            ConservationAction={conservationAction}
            OnConservationActionChange={setConservationAction}
            SurveyTypeId={surveyType.surveyTypeId}
            reloadData={loadConservationAction}
            {...props}
        />
    </Container>
};


